module.exports = __webpack_public_path__ + "static/media/clouds.11b0631f.jpeg";